module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "oldList"
  }, _vm._l((_vm.mapVersionsAgreement), function(list, index) {
    return _c('li', {
      key: index,
      class: {
        'isShow': _vm.idx === index
      },
      on: {
        "click": function($event) {
          return _vm.oldCange(index)
        }
      }
    }, [_vm._v("\n      " + _vm._s(list.object.mapUpdated_at) + "\n    ")])
  }), 0), _vm._v(" "), _c('code-diff', {
    attrs: {
      "old-string": _vm.oldAgreement,
      "new-string": _vm.newAgreement,
      "context": 10,
      "output-format": _vm.outputFormat
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12a4f596"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Agreement/AgreementDiff.vue
// module id = 1293
// module chunks = 0